<template>
  <div v-if="!loading" class="darkbg" @click="hideMe">
    <SimpleDishView v-if="!loading && !dish.about.deal" :dish="dish" @close="hideMe" />
    <DealDishView v-if="!loading && dish.about.deal" :dish="dish" @close="hideMe" />
  </div>
</template>
<script>
import {useRoute} from 'vue-router'
import {fetch3} from '@/modules/configuration.js'
import SimpleDishView from "@/views/SimpleDishView.vue";
import DealDishView from "@/views/DealDishView.vue";
// import PopupComponent from "@/components/PopupComponent.vue";

export default {
  components: {
    SimpleDishView,
    DealDishView,
    // PopupComponent,
  },
  data() {
    return {
      loading: true,
      data: {},
      popupOpen: false
    }
  },
  computed: {
    dish() {
      return this.data;
    }
  },
  methods: {
    async hideMe() {
      this.$router.push(this.data.cook.url)
    },
    async getData(url) {
      const data = await fetch3(this, {
        url: url,
        addQueryString: true
      });
      if (Object.keys(data).length ===0) return ;

      this.data = data;
      this.loading = false;
      if (data.title) {
        document.body.classList.add('noscroll');
      }

    }
  },
  mounted() {
    const route = useRoute();
    if (!route.params.dishid) {
      this.data = {};
      return;
    }
    this.getData("c/" + route.params.cookid + "/d/" + route.params.dishid);
  },
  unmounted() {
    document.body.classList.remove('noscroll');
  },
  watch: {
    $route(to) {
      if (to.params.cookid && to.params.dishid) {
        this.getData("c/" + to.params.cookid + "/d/" + to.params.dishid);
      }
    }
  },

}
</script>
<style scoped>
.darkbg {
  display: block;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1999;
}
.bottom-drawer {
  display: block;
  background-color: white;
  position: fixed;
  z-index: 2000;
  bottom: 0;
  left: 0;
  right: 0;
  top: 100px;
  overflow: none;
}

@media (min-width: 1200px) {
  .bottom-drawer {
    width: 510px !important;
    left: 50% !important;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    transform: translateX(-50%);
  }
}
</style>